module.exports = __webpack_public_path__ + "static/hp-tablet-device.34cadd4b.webp";